export default __webpack_public_path__ + "static/media/CamelNovel.1345bccd.png";